import { useImmerReducer } from 'use-immer';
import { NewAptitudeTestResponsesContext } from 'hooks/useNewAptitudeTestResponseContext';
import Assessments from './assessments';
import { initialState } from './utils/types';
import { reducer } from './utils/helper';

type startProps = {
  data: any;
};

const NewStartAptitudeTestScreen = (props: startProps) => {
  const aptitudeResponsesInitialState: initialState = {
    overallTimeLeft: { minutes: 0, seconds: 0 },
    categoryTimeLeft: { minutes: 0, seconds: 0 },
    currentCategoryNo: 0,
    currentQuestion: 0,
    responses: props.data.responses,
    totalQuestions: props.data.responses[0].questions.length,
    tabSwitchedCount: 0,
  };
  console.log(props.data);
  const [state, dispatch] = useImmerReducer(
    reducer,
    aptitudeResponsesInitialState
  );
  return (
    <NewAptitudeTestResponsesContext.Provider value={{ state, dispatch }}>
      <Assessments data={props.data} />
    </NewAptitudeTestResponsesContext.Provider>
  );
};

export default NewStartAptitudeTestScreen;
